/**
 * Converts a string into a dashify ID format.
 *
 * - Converts all characters to lowercase.
 * - Removes special characters (except spaces and dashes).
 * - Replaces spaces with dashes.
 * - Collapses multiple consecutive dashes into a single dash.
 * - Trims leading and trailing whitespace.
 *
 * @param str - The input string to convert.
 * @returns The dashified version of the input string.
 *
 * @example
 * dashify("Hello World! This is #Awesome");
 * // returns "hello-world-this-is-awesome"
 */
export function dashify(str: string) {
  return str
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')
    .trim()
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');
}
